// Module
var code = `<!-- §3 THE PATTERN — RATIFIED-WD (copy of record 2026-08-13; audit fixes 2026-08-16: #3 Acme slot commented out, #4 modifier, #5 tense, #7 triad, #8 phrase repeat) -->
<section class="vbl-section" aria-labelledby="vbl-headline">

    <div class="vbl-section__inner">

        <header class="vbl-section__header">
            <h2 id="vbl-headline" class="vbl-section__headline landing-headline"><span class="landing-eyebrow">THE PATTERN</span>
                VBL &mdash; View, Behavior, Logic.
            </h2>
            <p class="vbl-section__sub">
                Every browser mechanic fits one of three shapes: what renders (View), what moves
                (Behavior), what decides (Logic). Wired to each other in the codebase, the three
                shapes give the application its form. Structure is written, never guessed.
                <span class="vbl-section__spec-echo">This is how the Codebase becomes the Spec.</span>
            </p>

            <ul class="vbl-section__bullets">
                <li><strong>Real DOM, declarative Views</strong> &mdash; each View renders, syncs its content, and nests other Views, every region owned and updated independently. No reconciliation layer. The framework handles rendering through observable chaining and automation.</li>
                <li><strong>Wiring you can read</strong> &mdash; every connection between Behavior and Views lives in the code, visible before anything runs.</li>
                <li><strong>Outside content joins the stream</strong> &mdash; data, external events, and plugins enter through Channels and run as native behavior.
                </li>
                <li><strong>One rule at every scale</strong> &mdash; the same composition from hello world to the full application.</li>
            </ul>
        </header>

        <!-- Example header -->
        <div class="vbl-section__example-header">
            <h3 class="vbl-section__example-title">Hello World — View, Behavior, Logic</h3>
            <p class="vbl-section__example-desc">
                The minimal VBL pattern. No hidden lifecycle logic, no implicit control flow —
                what renders, what moves, and what decides are separated and visible from the start.
            </p>
        </div>

        <!-- Live code editor mount point -->
        <div class="vbl-section__codebox">
            <div class="code-container-holder">
                <!-- SpyneJS live code editor mounts here via .code-container -->
            </div>
        </div>

        <footer class="vbl-section__example-footer">
            <p class="vbl-section__example-note">
                The same relationships shown here scale unchanged as the application
                grows in complexity, depth, and scope.
            </p>
            <div class="vbl-section__footer-links">
                <a   data-channel="ROUTE"
                     data-event-prevent-default="true"
                     data-page-id="docs"
                     data-stage="examples"
                     data-text="Docs"
                     href="/docs/examples"
                     class="vbl-section__examples-cta">
                    See all examples →
                </a>
            </div>
            <!-- Acme slot — inert until post URL exists. Reactivate by uncommenting at publication:
            <p class="vbl-section__acme-slot">See it measured &mdash; the same dashboard, prompt to production. →</p>
            -->
        </footer>

    </div>

</section>
`;
// Exports
module.exports = code;